export default __webpack_public_path__ + "static/suzuki2_main-8c840c217cd98f55aafaaa219dfd1206.jpg";